import ClipboardM from '../model/recordm.model.clipboard.js';

import ui from '@cob/ui-genesis/cob.ui.js';

var ClipboardP = function(core) {

    var _model = new ClipboardM();

    var _parseUrlData = function(urlData) {
        /* eslint-disable-next-line no-eq-null */
        if (urlData != null) {
            try {
                try {
                    urlData = decodeURIComponent(urlData);
                } catch (e) {
                    //perhaps it's iso-8859-1? Fallback to unescape
                    urlData = unescape(urlData);
                }
                _model.set(JSON.parse(urlData));

            } catch (e) {
                window.console.error('Clipboard: error parsing json from url param data: ' + urlData);
                window.console.error(e);
                ui.notification.showError(
                    core.translateString("recordm.error.codes", "clipboard.parse-error"),
                    true
                );
            }
        }
    };


    var _init = function(urlData) {
        _parseUrlData(urlData);
    };

    return{
        init: _init,

        hasContentFor: function(def) {
            return _model.getFor(def) !== null;
        },
        getValueFor: function(def) {
            return _model.getFor(def);
        },
        autoPasteIfEmpty : function(){
            return _model.autoPasteIfEmpty();
        },
        setReadonlyOnPaste : function() {
            return _model.setReadonlyOnPaste();
        }
    }
};

export default ClipboardP;
